'use client';
import React from 'react'
import { CustomFooterLink } from './Links'
import { IoLogoInstagram } from 'react-icons/io';
import { RiHandHeartLine } from 'react-icons/ri';
import { FaExclamation } from 'react-icons/fa';
import Link from 'next/link';

const Footer = () => {
  return (
    <footer className='w-full bg-black text-white flex flex-col justify-center space-y-10 font-medium p-5 tablet:p-10'>
      <nav className='flex flex-col items-center space-y-4 '>
          <CustomFooterLink title="home" href='/' />
          <CustomFooterLink title="portfolio" href='/portfolio' />
          <CustomFooterLink title="collection" href='/collection' />
          <CustomFooterLink title="purpose" href='/purpose' />
          <CustomFooterLink title="contact" href='/contact' />
      </nav>
      <div className='space-x-6 flex flex-row items-center justify-center'>
          <Link 
          className=' hover:text-hover justify-center' 
          href='https://www.etsy.com/uk/shop/AthenaMERCURY?ref=profile_header&load_webview=1&bid=GeHU6ixOLLWIavmm94C10LU7C0tm&load_webview=1&bid=GeHU6ixOLLWIavmm94C10LU7C0tm'
          >
            <p className='font-text'>ETSY</p>
          </Link>
          <Link 
          className=' hover:text-hover justify-center text-3xl' 
          href='https://www.instagram.com/athena_mercury_london/'
          >
            <IoLogoInstagram/>
          </Link>
      </div>
      <div className='space-y-6 flex flex-col items-center justify-center'>
        <h1 className='text-lg font-extrabold'>Charities</h1>
        <div className='flex items-center flex-col justify-center space-y-6'>
          <Link 
          className=' hover:text-hover justify-center' 
          href='https://www.actionaid.org.uk/'
          >
            <div className='flex flex-col items-center'>
            <FaExclamation/>
            <p>ACT!ONAID</p>
            </div>
          </Link>
          <Link 
          className=' hover:text-hover justify-center' 
          href='https://refuge.org.uk/'
          >
            <div className='flex flex-col items-center'>
            <RiHandHeartLine/>
            <p>REFUGE</p>
            </div>
          </Link>
        </div>
      </div>
      <div className='flex flex-col items-center justify-center'>
        <Link className="uppercase relative group hover:text-hover text-center text-2xl mobile:text-3xl tablet:text-5xl laptop:text-6xl" 
        href="/"
        >
          Athena Mercury
            <span className="h-[1px] inline-block absolute left-0 -bottom-0.5 group-hover:w-full group-hover:bg-hover text-hover transition-[width] ease duration-300">
              &nbsp;
            </span>
        </Link>
        <span className='pb-5 pt-10 text-center text-sm'>{new Date().getFullYear()} &copy; Athena Mercury, All Rights Reserved</span>
      </div>
    </footer>
  )
}

export default Footer